export const useScrollDirection = () => {
  const lastScrollTop = ref(0)
  const isScrollingDown = ref(false)
  
  const handleScroll = () => {
    const st = window.pageYOffset || document.documentElement.scrollTop
    isScrollingDown.value = st > lastScrollTop.value && st > 50
    lastScrollTop.value = st
  }

  onMounted(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll)
  })

  return {
    isScrollingDown
  }
}